<template>
    <div class="flex flex-column w-full" style="color: var(--theme-font-color);">
        <div class="flex flex-row justify-content-between">
            <div style="width: 45%;" class="detail align-items-start">
                <span class="subtitle mt-0">{{ license.product.type == "Main" ? "Application" : license.product.type }}</span>
                <span class="subtext">{{ license.product.application }}</span>
            </div>
            <div style="width: 10%;" class="detail align-items-center" v-if="license.product.version != 0">
                <span class="subtitle mt-0">Version</span>
                <span class="subtext">{{ license.product.version }}</span>
            </div>
            <div style="width: 45%;" class="detail align-items-end">
                <span class="subtitle mt-0">Issue Date</span>
                <span class="subtext">{{ license.history.issue_date ? format(new Date(license.history.issue_date), 'MMM do, yyyy') : "/" }}</span>
            </div>
        </div>
        <div class="flex flex-row justify-content-between gap-3">
            <div style="width: 45%;" class="detail align-items-start">
                <span class="subtitle">Description</span>
                <div>
                    <span v-if="license.product.exp !== '-1'" class="subtext">Temporary (until {{ license.product.exp ? format(new Date(license.product.exp), 'MMM do, yyyy') : "/" }}), </span>
                    <span v-if="license.product.options.length>0">
                        <span v-for="(val, index) in license.product.options" class="subtext" :key="index">{{ val.label }}{{ (index<license.product.options.length-1) ? ', ' : '' }}</span>
                    </span>
                    <span v-else class="subtext">No additional options</span>
                </div>
            </div>
            <div style="width: 10%;" class="detail align-items-center">
                <span class="subtitle mt-0">Channels</span>
                <span class="subtext">{{ license.product.channels }}</span>
            </div>
            <div style="width: 45%;" class="detail align-items-end">
                <span class="subtitle">Owner</span>
                <span class="subtext text-end" style="text-align: end;">{{ license.admin.first_name }} {{ license.admin.last_name }} ({{ license.admin.email }}){{ (license.admin.email===user.email) ? ' - You' : '' }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { toRefs, computed } from 'vue';
// Others
import { useStore } from 'vuex';
import { format } from 'date-fns';

const store = useStore()
// --- PROPS ---
const props = defineProps({
    license: Object
})
const { license } = toRefs(props)

// --- User info ---
const user = computed(() => store.state.user.user)

// --- EMITS ---
const emit = defineEmits(['changing', 'reset', 'delegates-changed'])
</script>

<style scoped>
.detail {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    margin-top: 1rem;
}
</style>